import * as types from "../mutation-types";
import services from "services/organization";
import _ from "lodash";

const state = {
  trainings: [],
  selectedTraining: {},
  selectedSchool: {},
  selectedCampus: {},
  selectedDocument: {},
  schools: [],
  campuses: [],
  documents: [],
  scholarYears: [],
  currentYear: null,
  nextYear: null,
  trim2: null,
  trim3: null,
  themes: [],
  filter: "all",
  pagination: [],
  totalPages: "",
  currentPage: ""
};

const getters = {
  schools(state) {
    return state.schools;
  },
  getSchoolBySlug: state => slug => {
    return state.schools.find(school => school.slug === slug);
  },
  schoolById: state => id => {
    return state.schools.find(school => school.id === id);
  },
  schoolByType: state => type => {
    return state.schools.filter(school => school.type === type);
  },
  schoolByTypeId: state => type => {
    return state.schools.filter(school => school.type_id === type);
  },
  scholarYears(state) {
    return state.scholarYears;
  },
  currentScholarYear(state) {
    return state.currentYear;
  },
  nextScholarYear(state) {
    return state.nextYear;
  },
  trim2(state) {
    return moment(state.trim2, 'DD/MM/YYYY');
  },
  trim3(state) {
    return moment(state.trim3, 'DD/MM/YYYY');
  },
  campuses(state) {
    return _.sortBy(state.campuses, campus => campus.name.toLowerCase());
  },
  campusById: state => id => {
    return state.campuses.find(campus => campus.id === id);
  },
  campusBySlug: state => slug => {
    return state.campuses.find(campus => campus.slug === slug);
  },
  themes(state) {
    return state.themes;
  },
  trainings(state) {
    return state.trainings;
  },
  trainingById: state => id => {
    return state.trainings.find(training => training.id === id);
  },
  totalTrainingPages(state) {
    return state.totalPages;
  },
  currentTrainingPage(state) {
    return state.currentPage;
  },
  trainingPagination(state) {
    const { total, limit, skip } = state.pagination;
    return _.extend(state.pagination, {
      pages: Math.ceil(total / limit),
      current: Math.ceil((skip - 1) / limit) + 1
    });
  },
  selectTraining(state) {
    return state.selectedTraining;
  },
  selectSchool(state) {
    return state.selectedSchool;
  },
  selectCampus(state) {
    return state.selectedCampus;
  },
  documents(state) {
    return state.documents;
  },
  selectedDocument(state) {
    return state.selectedDocument;
  }
};

const mutations = {
  [types.FETCH_SCHOOLS](state, schools) {
    state.schools = schools;
  },

  [types.ADD_SCHOOL](state, school) {
    state.schools.unshift(school);
    state.selectedSchool = school;
  },

  [types.UPDATE_SCHOOL](state, school) {
    // find the index of the obj to remove from array
    const index = _.findIndex(state.schools, { id: school.id });
    // Replace element at index
    state.schools.splice(index, 1, school);
  },


  [types.FETCH_SCHOLARYEARS](state, scholarYears) {
    state.scholarYears = scholarYears.scholar_years;
    state.currentYear = scholarYears.current_year;
    state.nextYear = scholarYears.next_year;
    state.trim2 = scholarYears.trim2;
    state.trim3 = scholarYears.trim3;
  },

  [types.FETCH_CAMPUSES](state, campuses) {
    state.campuses = campuses;
  },

  [types.FETCH_DOCUMENTS](state, documents) {
    state.documents = documents;
  },

  [types.FETCH_THEMES](state, themes) {
    state.themes = themes.themes;
  },

  [types.FETCH_TRAININGS](state, trainings) {
    state.trainings = trainings.data.trainings;
    state.pagination = trainings.data.meta.pagination;
    state.totalPages = state.pagination.total_pages;
    state.currentPage = state.pagination.current_page;
  },

  [types.ADD_TRAINING](state, training) {
    state.trainings.unshift(training);
    state.pagination.total++;
  },

  [types.UPDATE_TRAINING](state, training) {
    // find the index of the obj to remove from array
    const index = _.findIndex(state.trainings, { id: training.id });
    // Replace element at index
    state.trainings.splice(index, 1, training);
  },

  [types.REMOVE_TRAINING](state, training) {
    // find the index of the obj to remove from array
    const index = _.findIndex(state.trainings, { _id: training._id });
    // remove the obj at position [index] from array
    state.trainings.$remove(state.trainings[index]);
  },

  selectTraining: (state, payload) => {
    state.selectedTraining = payload;
  },

  selectSchool: (state, payload) => {
    state.selectedSchool = payload;
  },
  selectCampus: (state, payload) => {
    state.selectedCampus = payload;
  },
  selectDocument: (state, payload) => {
    state.selectedDocument = payload;
  }
};

const actions = {
  fetchSchools: ({ commit }, query) => {
    services.schools(query).then(schools => {
      commit(types.FETCH_SCHOOLS, schools.data);
    });
  },
  async selectSchool({ commit }, slug) {
    const payload = (await services.showSchool(slug)).data;
    commit("selectSchool", await payload);
  },
  async addSchool({ commit }, school) {
    const payload = (await services.addSchool(school)).data;
    commit(types.ADD_SCHOOL, await payload);
  },

  async updateSchool({ commit }, school) {
    const payload = (await services.editSchool(school)).data;
    commit(types.UPDATE_SCHOOL, await payload);
  },

  async addSchoolDocument({ commit }, school) {
    const payload = (await services.addSchoolDocument(school)).data;
    commit(types.UPDATE_SCHOOL, await payload);
  },

  async delSchoolDocument({ commit }, doc) {
    const payload = (await services.delSchoolDocument(doc)).data;
    commit(types.UPDATE_SCHOOL, await payload);
  },

  fetchDocuments: ({ commit }, query) => {
    services.documents(query).then(documents => {
      commit(types.FETCH_DOCUMENTS, documents.data);
    });
  },

  async selectDocument({ commit }, id) {
    const payload = (await services.document(id)).data;
    commit("selectDocument", await payload);
  },

  resetSchool({ commit }) {
    commit("selectSchool", {});
  },

  resetDocument({ commit }) {
    commit("selectDocument", {});
  },

  fetchScholarYears: ({ commit }) => {
    services.scholarYears().then(scholarYears => {
      commit(types.FETCH_SCHOLARYEARS, scholarYears.data);
    });
  },
  async selectCampus({ commit }, slug) {
    const payload = (await services.showCampus(slug)).data;
    commit("selectCampus", await payload);
  },
  resetCampus({ commit }) {
    commit("selectCampus", {});
  },

  fetchCampuses: ({ commit }, query) => {
    // Call the events service on the server via websocket
    services.campuses(query).then(campuses => {
      commit(types.FETCH_CAMPUSES, campuses.data);
    });
  },

  fetchAllCampuses: ({ commit }, query) => {
    // Call the events service on the server via websocket
    services.allCampuses(query).then(campuses => {
      commit(types.FETCH_CAMPUSES, campuses.data);
    });
  },

  fetchThemes: ({ commit }, query) => {
    // Call the events service on the server via websocket
    services.themes(query).then(themes => {
      commit(types.FETCH_THEMES, themes.data);
    });
  },
  async removeTheme({ commit }, data) {
    const payload = (await services.deleteTheme(data)).data;
  },

  fetchTrainings: ({ commit }, query) => {
    services.trainings(query).then(trainings => {
      commit(types.FETCH_TRAININGS, trainings);
    });
  },
  fetchTrainingsList: ({ commit }, query) => {
    services.trainingsList(query).then(trainings => {
      commit(types.FETCH_TRAININGS, trainings);
    });
  },
  newTraining: ({ commit }, training) => {
    commit(types.ADD_TRAINING, training);
  },
  resetTraining({ commit }) {
    // requires_study à true par défaut : une nouvelle formation nécessite une étude de dossier.
    commit("selectTraining", { requires_study: true });
  },
  async selectTraining({ commit }, id) {
    const payload = (await services.training(id)).data;
    commit("selectTraining", await payload);
  },
  async updateTraining({ commit }, training) {
    const payload = (await services.editTraining(training.id, training)).data;
    commit(types.UPDATE_TRAINING, training);
    commit("selectTraining", await payload);
  },
  updatedTraining: ({ commit }, training) => {
    commit(types.UPDATE_TRAINING, training);
  },
  async archiveTraining({ commit }, training) {
    const payload = (await services.archiveTraining(training)).data;
    //commit(types.REMOVE_TRAINING, training)
  },

  async removeTrainingOption({ commit }, training) {
    const payload = (await services.deleteTrainingOption(training)).data;
    commit(types.UPDATE_TRAINING, training);
  },

  newFees: ({ commit }, fees) => {
    services.addRegistrationFee(fees).then(training => {
      commit(types.UPDATE_TRAINING, training.data);
      commit("selectTraining", training.data);
    });
  },
  newDates: ({ commit }, fees) => {
    return services.addTrainingDates(fees).then(training => {
      commit(types.UPDATE_TRAINING, training.data);
      commit("selectTraining", training.data);
    });
  },
  newCapacities: ({ commit }, capacities) => {
    services.addTrainingCapacities(capacities).then(training => {
      commit(types.UPDATE_TRAINING, training.data);
      commit("selectTraining", training.data);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
